import localesEn from '@/shared/i18n/AuthB2C/en';
import { REGISTER_PAGE_KEY } from '@/views/Register/constants';

const en = {
  [REGISTER_PAGE_KEY]: {
    ...localesEn,
    SEO_TITLE: 'Sign up',
    DESCRIPTION_SEO: 'Be part of the new generation of digital professionals.',

    YOU_HAVE_ACCOUNT: 'Do you have an account?',
    JOIN_CREHANA: 'Join today',
    REGISTER_TO_CREHANA: 'Register with your phone number',
    REGISTER: 'Register',
    OR_ALSO: 'or also',
    DO_YOU_HAVE_A_ACCOUNT: 'Do you have an account?',
    LIVE_EXPERIENCE_CREHANA: 'Start your learning journey',
    LEGALS_TEXT_1: 'I accept the ',
    LEGALS_TEXT_2: 'Terms, Conditions and Policies of Crehana.',
    AUTH_VALIDATION_LEGALS_REQUIRED:
      'You must accept the Terms, Conditions and Policies to continue.',
    LOGIN_GOOGLE_LABEL: 'Continue with Google',
    LOGIN_FACEBOOK_LABEL: 'Continue with Facebook',
    SOCIAL_BUTTON_TEXT: 'Register with',
    SOCIAL_BUTTON_TEXT_LOGIN: 'Sign in with ',
    CAMPAIGN_AUTH_TITLE:
      'Redeem your package of 10 online courses thanks to HP.',
    CAMPAIGN_AUTH_SUBTITLE: 'Before you start, register or log in.',
    PHONE: 'Phone',

    // Validation
    INPUT_REQUIRED: 'Required field',
    VALIDATE_MAX_PASSWORD: 'Your password must be a maximum of 6 characters',
    VALIDATE_MIN_PASSWORD: 'Your password must be at least 6 characters',
    VALIDATE_FORMAT_EMAIL: 'Please enter a valid email address.',
    PASSWORD_DOES_NOT_MATCH: 'The passwords do not match',

    SIGN_IN: 'Log in',
    EMAIL: 'Email',
    PASSWORD: 'Password',

    CHECKBOX_DATA_USAGE:
      'I authorize Crehana to use the provided data to contact me and receive promotions, offers and information on new products.',
  },
};

export default en;
